/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{margin:4% 26%;font-family:Montserrat-Light,sans-serif;color:#b62027;font-size:22px}img[_ngcontent-%COMP%]{width:180px}\n/*# sourceMappingURL=login-error.component.css.map*/"];
export { styles as styles };
